import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, MenuItem, Select, TextField, Typography, Grid, IconButton } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { createFetchDataServer } from '../../../database/fetchData';
import { DataContext } from '../pagesMains/GravesManagers/Graves';
import useQueries from '../../../database/useQueries';
import { v4 as uuidv4 } from 'uuid';

const CityDefinitionForm = ({ countries = [], cities = [] }) => {  
  
  const context = useContext(DataContext);
  const [defaultRows, setDefaultRows] = useState(false);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { AllDataResidencies,
    addOrUpdateDataResidency,
    removeResidency } = useQueries();


  // Handle default values for props
  const defaultCountries = countries.length
    ? countries
    : [
        { nameCountryHe: 'ישראל', nameCountryEn: 'Israel', unicId: '1' },
        { nameCountryHe: 'ארה"ב', nameCountryEn: 'USA', unicId: '2' }
      ];

  const defaultCities = cities.length
    ? cities
    : [
        { nameCityHe: 'תל אביב', nameCityHe: 'Tel Aviv', countryId: '1', unicId: '101' },
        { nameCityHe: 'ניו יורק', nameCityHe: 'New York', countryId: '2', unicId: '201' }
      ];

  const defaultRates = [
    { name: 'תושב ירושלים והסביבה', value: '1' },
    { name: 'תושב הארץ', value: '2' },
    { name: 'תושב חוץ לארץ', value: '3' }
  ];

  const [rows, setRows] = useState([{ country: '', city: '', rate: '' }]);

  useEffect(() => {
    if (!defaultRows && context?.contextResidencies) {      
      setRows(
        [...context?.contextResidencies,
        { country: '', city: '', rate: '' }]
      )
      setDefaultRows(true)
    }
  }, [context]);

  const handleAddRow = () => {
    setRows([...rows, { country: '', city: '', rate: '' }]);
  };

  const handleRemoveRow = (index) => {
    setRows(rows.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    const updatedRows = rows.map((row, i) => (i === index ? { ...row, [field]: value } : row));
    setRows(updatedRows);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
      const unicId = uuidv4();

      let res = await addOrUpdateDataResidency(rows.filter(r => {
        return !r.unicId && r
      }), unicId);
      if (res === 200) {
      }
    // }
  };

  return (
    <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '8px' }}>
      {rows.map((row, index) => (
        <Box key={index} mb={2}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={4}>
              <Select fullWidth value={row.country} onChange={(e) => handleChange(index, 'country', e.target.value)} displayEmpty>
                <MenuItem value="" disabled>
                  בחר מדינה
                </MenuItem>
                {context?.contextCountries.map((country) => (
                  <MenuItem key={country.unicId} value={country.unicId}>
                    {`${country.countryNameHe} / ${country.countryNameEn}`}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={4}>
              <Select fullWidth value={row.city} onChange={(e) => handleChange(index, 'city', e.target.value)} displayEmpty disabled={!row.country}>
                <MenuItem value="" disabled>
                  בחר עיר
                </MenuItem>
                {context?.contextCities
                  .filter((city) => city.countryId === row.country)
                  .map((city) => (
                    <MenuItem key={city.unicId} value={city.unicId}>
                      {`${city.cityNameHe} / ${city.cityNameHe}`}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={3}>
              <Select fullWidth value={row.rate} onChange={(e) => handleChange(index, 'rate', e.target.value)} displayEmpty>
                <MenuItem value="" disabled>
                  בחר תעריף
                </MenuItem>
                {defaultRates.map((rate) => (
                  <MenuItem key={rate.value} value={rate.value}>
                    {rate.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={1}>
              {index > 0 && (
                <IconButton color="error" onClick={() => handleRemoveRow(index)}>
                  <RemoveCircleOutlineIcon />
                </IconButton>
              )}
            </Grid>
          </Grid>
        </Box>
      ))}
      <Box mt={2}>
        <Button variant="contained" color="primary" startIcon={<AddCircleOutlineIcon />} onClick={handleAddRow}>
          הוסף רובריקה
        </Button>
      </Box>
      <Box mt={2}>
        <Button variant="contained" color="success" onClick={handleSubmit}>
          שליחה
        </Button>
      </Box>
    </Box>
  );
};

export default CityDefinitionForm;
